import Accounts from './Accounts'

export default Accounts
